export default __webpack_public_path__ + "static/media/iphone.2242b502.png";